import React, { Fragment, useState, useEffect } from "react";
import GetStudentService from "../../../services/SchoolIT/GetStudentService";
import { useHistory } from "react-router";
import CustomLoader from "../../customLoader/CustomLoader";
import Loader from "react-loader-spinner";
import swal from "sweetalert";
import "../../admin/StudentProgress/StudentProgress.css";
import "./GoalCriteriaOrSetup.css";
let addGoalOrUpdateGoal = [];

const Goals = () => {
  const [goalPageData, setGoalPageData] = useState();
  const [page] = useState(1);
  const [user] = useState(
    localStorage.getItem("user") && JSON.parse(localStorage.getItem("user"))
  );
  const [deleteGoalId, setDeleteGoalId] = useState();
  const [loading, setLoading] = useState(false);
  const [publishedLoading, setPublishedLoading] = useState(false);
  const [checkbox, setCheckbox] = useState(true);
  const [publishedButtonIndex, setPublishedButtonIndex] = useState(-1);
  const [uncheck, setUncheck] = useState([]);
  let history = useHistory();

  const getGoalPageData = () => {
    setLoading(true);
    let obj = {
      page: page,
      role: "school_it",
      school: user?.school_id
    };
    GetStudentService.goalPage(obj)
    .then((data) => {
      setGoalPageData(data.data);
      let convertedData = DataMapping(data?.data?.result);
      if (convertedData.length > 0) {
        setConvertedDataToGoalpageData(convertedData);
      }
      setLoading(false);
    })
    .catch((_error) => {
      setLoading(false);
    });
  };

  const duplicateGoal = (value) => {
    let obj = {
      goal_id: value?.id,
      school: user?.school_id
    };
    GetStudentService.duplicateGoal(obj)
    .then((_data) => {
      getGoalPageData();
    })
    .catch(() => {});
  };

  const deleteGoalRequirement = (value) => {
    const goalId = value?.id;
    setDeleteGoalId(goalId);
    let obj = {
      goal_id: goalId
    };
    GetStudentService.deleteGoalRequirement(obj)
    .then(async () => {
      const confirmed = await swal({
        title: "Delete?",
        text: "Are you sure you want to delete?",
        icon: "warning",
        buttons: {
          cancel: "Cancel",
          confirm: "OK"
        },
        dangerMode: true,
        closeOnClickOutside: false
      });
      if (confirmed) {
        deleteGoalAfterRequirement(goalId);
      }
    })
    .catch(() => {});
  };

  const deleteGoalAfterRequirement = (goalId = deleteGoalId) => {
    let obj = {
      deleted: true
    };
    GetStudentService.deleteGoal(obj)
    .then((_data) => {
      goalDeleteConfirmation(goalId);
    })
    .catch(() => {});
  };











  const goalDeleteConfirmation = (value) => {
    let obj = {
      delete_goal_id: value
    };
    GetStudentService.deleteGoalConfirmation(obj)
    .then((_data) => {
      setDeleteGoalId();
      getGoalPageData();
    })
    .catch(() => {});
  };

  const updateDefaultGoal = () => {
    let obj = {
      check: uncheck,
      default: addGoalOrUpdateGoal,
      school: user?.school_id
    };
    GetStudentService.updateDefaultGoal(obj)
    .then((_data) => {
      getGoalPageData();
    })
    .catch(() => {});
  };

  const DataMapping = (value) => {
    for (let i = 0; i < value.length; i++) {
      for (let j = 0; j < value[i].publish_data.length; j++) {
        if (value[i].publish_data[j].school_id == user?.school_id) {
          value[i].published = value[i].publish_data[j].published;
          value[i].data = value[i].publish_data[j].data_mapped_percentage;
        }
        if (value[i].publish_data[j].default_goal === true) {
          value[i].default_goal = value[i].publish_data[j].default_goal;
        }
      }
      if (value[i].published == "" && value[i].data == "") {
        for (let j = 0; j < value[i].publish_data.length; j++) {
          if (value[i].publish_data[j].school_id == null) {
            value[i].published = value[i].publish_data[j].published;

            value[i].data = value[i].publish_data[j].data_mapped_percentage;
          }
        }
      }
    }
    return value;
  };

  const publishOrUnPublishGoal = (item, index, publishValue) => {
    setPublishedLoading(true);
    setPublishedButtonIndex(index);
    let obj = {
      goal_id: item?.id,
      published: publishValue,
      school: user?.school_id
    };
    GetStudentService.goalPublished(obj)
    .then((data) => {
      setPublishedLoading(false);
      if (data?.data?.goal_id?.length > 0 && data?.data?.map === 1) {
        swal({
          text: `This Goal/Course has been used by a counselor. Cannot be unpublished.`,
          icon: "warning",
          dangerMode: true,
          buttons: {
            cancel: true
          },
          closeOnClickOutside: false
        });
      } else {
        getGoalPageData();
      }
      setPublishedLoading(false);
    })
    .catch((_error) => {
      setPublishedLoading(false);
    });
  };

  const setConvertedDataToGoalpageData = (data) => {
    if (data) {
      setGoalPageData({ ...goalPageData, result: data });
      let defaultGoal = data
      ?.filter((item) => {
        if (item.published === true) {
          return item?.id;
        }
      })
      .map((item) => item.id);
      addGoalOrUpdateGoal = defaultGoal;
      let uncheck = data
      ?.filter((item) => item.published === false)
      .map((item) => item?.id);
      setUncheck(uncheck);
    }
  };

  const openGoalView = (value) => {
    history.push(`/school_it/goal/${value?.id}`);
  };





  const undoGoalDelete = (value) => {
    let obj = {
      goal_id: value?.id,
      deleted: "True"
    };
    GetStudentService.undoGoalDelete(obj)
    .then((_data) => {
      getGoalPageData();
    })
    .catch(() => {});
  };

  const checkedGoal = (_value) => {
    setCheckbox(!checkbox);
  };

  useEffect(() => {
    // deleteUndoGoal();
    getGoalPageData();
  }, []);

  const renderPublishSpinner = (index) =>
  publishedButtonIndex === index && publishedLoading ?
  <Loader type="TailSpin" color="white" height={16} width={16} /> :
  null;

  return (
    <Fragment>
      <div className="admin-ccplus-panel-header">
        <div>
          <h2 className="admin-ccplus-panel-title">Goals</h2>
          <p className="admin-ccplus-panel-hint">
            Create, publish, and manage student goals
          </p>
        </div>
        <div style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
          <button
            type="button"
            onClick={() => history.push("/school_it/create_goal")}
            className="admin-ccplus-btn primary toolbar">

            New Goals
          </button>
          {addGoalOrUpdateGoal?.length > 0 ?
          <button
            type="button"
            onClick={updateDefaultGoal}
            disabled={checkbox}
            className="admin-ccplus-btn secondary toolbar">

              Update Default Goals
            </button> :

          <button
            type="button"
            disabled={checkbox}
            className="admin-ccplus-btn secondary toolbar">

              Add Default Goals
            </button>}

        </div>
      </div>

      {loading ?
      <div className="admin-ccplus-list-loading">
          <CustomLoader variant="inline" color="#007bff" size={42} />
        </div> :

      <div className="admin-ccplus-list">
          {goalPageData?.result?.length > 0 ?
        goalPageData.result.map((item, index) =>
        <div
          key={item?.id || index}
          className={`admin-ccplus-item ${item?.deleted ? "is-deleted" : ""}`}>

                <div className="admin-ccplus-item-main">
                  <p className="admin-ccplus-item-name">{item?.goal_name}</p>
                  <div className="admin-ccplus-item-meta">
                    {item?.deleted ?
              <span className="admin-ccplus-badge deleted">Deleted</span> :
              item?.published ?
              <span className="admin-ccplus-badge broadcast">Published</span> :

              <span className="admin-ccplus-badge conceal">Unpublished</span>}

                    <span className="school-it-ccplus-mapping">
                      Data Mapping: {item?.data === "" || item?.data == null ? "0" : item?.data}%
                      {!!item?.published &&
                <label className="school-it-ccplus-default">
                          <input
                    onClick={() => checkedGoal(!item.default_goal)}
                    type="checkbox"
                    checked={item?.default_goal}
                    readOnly />

                          Default
                        </label>}

                    </span>
                  </div>
                </div>

                <div className="admin-ccplus-item-actions">
                  {item.published && item.deleted === false ?
            <button
              type="button"
              onClick={() => publishOrUnPublishGoal(item, index, "False")}
              className="admin-ccplus-btn conceal">

                      UnPublish
                      {renderPublishSpinner(index)}
                    </button> :
            !item?.published && item.deleted === false ?
            <button
              type="button"
              disabled={item?.data < 100 || item?.data == null}
              className="admin-ccplus-btn broadcast"
              onClick={() => publishOrUnPublishGoal(item, index, "True")}>

                      Publish
                      {renderPublishSpinner(index)}
                    </button> :
            null}

                  {item.deleted === false &&
            <button
              type="button"
              className="admin-ccplus-btn primary"
              onClick={() => duplicateGoal(item)}>

                      Duplicate
                    </button>}


                  {item?.is_global && item.deleted === false &&
            <button
              type="button"
              onClick={() => openGoalView(item)}
              className="admin-ccplus-btn secondary">

                      View
                    </button>}


                  {item?.is_global === false && item?.deleted === false ?
            <button
              type="button"
              onClick={() => openGoalView(item)}
              className="admin-ccplus-btn secondary">

                      Edit
                    </button> :
            null}

                  {!item?.is_global && item.deleted === false &&
            <button
              type="button"
              className="admin-ccplus-btn primary"
              onClick={() => deleteGoalRequirement(item)}>

                      Delete
                    </button>}


                  {item?.deleted &&
            <button
              type="button"
              onClick={() => undoGoalDelete(item)}
              className="admin-ccplus-btn danger">

                      Undo
                    </button>}

                </div>
              </div>
        ) :

        <p className="admin-ccplus-empty">No goals found</p>}

        </div>}

    </Fragment>);

};

export default Goals;